// removed by extract-text-webpack-plugin
module.exports = {"FestivalList":"OldFestivalList__FestivalList__390FX","Festival":"OldFestivalList__Festival__3ZGJt","Info":"OldFestivalList__Info__Z2fUh","Year":"OldFestivalList__Year__2Pyvp"};